//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "gold",
  props: {
    userinfo: undefined
  },
  data() {
    return {
      initialPagination: {
        sortBy: 'time',
        descending: true,
        page: 1,
        rowsPerPage: 20
        // rowsNumber: xx if getting data from a server
      },
      tab: "mygold",
      goldrecord_list: undefined,
      columns: [
        {
          name: 'num',
          required: true,
          label: '金币数量',
          align: 'left',
          field: row => row.num,
          sortable: true
        },
        {
          name: 'time',
          required: true,
          label: '时间',
          align: 'left',
          field: row => this.getdate(row.time * 1000, true),
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'action',
          required: true,
          label: '描述',
          align: 'left',
          field: row => row.action,
          format: val => `${val}`,
          sortable: true
        }
      ],
      goldrecord_title: "金币记录"
    }
  },
  methods: {
    buy_gold: function () {

    },
    on_tab_event: function (e) {
      console.log("on_tab_event:", e);
      var show_method_name = "show_" + e;
      let show_method = this[show_method_name];
      if (show_method) {
        show_method()
      }
    },
    show_mygold: function () {

    },
    show_goldrecord: function () {
      console.log("call show_goldrecord");

      this.$axios.get("/app/gold/logs").then((response) => {
        console.log("gold logs response:", response)
        this.goldrecord_list = response.data.datas;
        this.goldrecord_title = "金币记录 " + response.data.datas.length;
      })
    }
  }
}
